/** W82: Kontexte der Welt. `WeltKontext` sagt Bestandsbausteinen, dass sie unter einer Wurzel mit data-welt stehen
 *  (Druck und Gleiten nach Fassung statt der Schiefer-Federn). `SprecherKontext` trägt die Figur, an der eine Blase
 *  hängt (Sprecher-Regel): ohne Figur keine Blase. */
import { createContext } from "react";

/** W82 Teil 4 (Punkt 5): data-welt steht global an <html>, jede Seite gehört zur Welt; der Kontext gilt darum auch ohne
 *  Wurzel (Blätter und Rückfragen öffentlicher Seiten tragen die W82-Gestalt). */
export const WeltKontext = createContext(true);

export type Sprecher = "szene" | "ebene" | "rand";
export const SprecherKontext = createContext<Sprecher | null>(null);
